module.exports = __webpack_public_path__ + "static/media/loanMoney.a95e40bb.svg";